module.exports = __webpack_public_path__ + "static/media/loan-against-property.e9b620fc.jpeg";